'use strict';

import { queryFirst, addClass, removeClass, hasClass, queryAll, scrollTo, setAttribute, throttle } from '../domUtil';
import base from './base';
import { updateProductData, handleColor, handleSize } from 'fitpredictor/product/secretsauce';
const { isShippingPreferencesViewEnabled, isEarlyAccessElement, handleNotifyMe } = require('./helper');
const { availabilityMessageTmpl, restrictedMessageTmpl, availabilityMessageOOS, availabilityMessagePreorder, ispuAvailabilityMessageTmpl, ispuLowStockMessageTmpl } = require('../templates').productDetail;
const $body = $('body');
const sizeChartClasses = 'no-scroll size-chart-visible';
var Hammer = require('hammerjs');
const KEYCODE_TAB = 9;
const TabKey = 'Tab';
const {
    IN_STOCK_STATUS: IN_STOCK, NOT_AVAILABLE_STATUS: NOT_AVAILABLE, PREORDER_STATUS: PREORDER, HIDDEN_CLASS
} = require('../constants');
const { SHIP_TO_LOW_INVENTORY_CLASS, NOT_AVAILABLE_CLASS } = require('../components/shippingPreference/constants');

/**
 * Handling zoomin effect on product image slider
 */
function handleProductImageZoom() {
    const pdpPageCarousels = queryFirst('.product-detail');
    const carousel = $('.primary-images .carousel:not(.tile-carousel)');
    const imageZoomUrl = carousel.data('image');
    const imagePresetUrl = carousel.data('preset');

    const imageObserver = new MutationObserver(function (mutationList) {
        for (let mutation of mutationList) {
            if (mutation.type === 'childList') {
                const { target, addedNodes } = mutation;
                const baseImg = queryFirst('.img-fluid', target);
                const zoomAlt = baseImg.getAttribute('alt') + ' Zoomed';
                setAttribute(addedNodes, 'alt', zoomAlt);
            }
        }
    });

    if (pdpPageCarousels && pdpPageCarousels.length > 0) {
        const pdpImages = queryAll('.primary-images .carousel-item');
        const pdpIndicators = queryAll('.primary-images .carousel-indicators li');

        pdpImages.forEach((img, index) => {
            const imageEl = queryFirst('img', img);
            if (!imageEl) {
                return;
            }
            imageEl.setAttribute('data-src-hires', imageEl.getAttribute('data-src').replace(imagePresetUrl, imageZoomUrl));
            let scale = 0.35;
            let zoomed = false;
            let mobileZoomed = false;
            /**
             * Handling zoomin effect logic
             * @param {jQuery} elm -  DOM element for current image
             * @param {boolean} zoomed - boolean value if zoomed or not
             */
            function createTouchZoom(elm) {
                var thisHammer = new Hammer(elm, {});
                thisHammer.domEvents = true;
                thisHammer.get('pinch').set({ enable: true });

                let transform = '';
                let el = elm;
                let panSpeed = 1.1;
                let xPos = { current: 0, last: 0, max: 0 };
                let yPos = { current: 0, last: 0, max: 0 };
                let scale = { current: 2, last: 2, max: 4 };

                el.style.transform = `translate(${xPos.current}px,${yPos.current}px) scale(${scale.current},${scale.current})`;

                thisHammer.on('tap pan pinch panend pinchend', function (e) {
                    // Prevent tap events from interfering
                    e.srcEvent.stopPropagation();
                    e.srcEvent.preventDefault();
                    // If zoomed in, pan the image
                    if (scale.current !== 1) {
                        xPos.current = xPos.last + e.deltaX * panSpeed;
                        yPos.current = yPos.last + e.deltaY * panSpeed;
                        xPos.max = Math.ceil(((scale.current - 1) * el.clientWidth) / 2);
                        yPos.max = Math.ceil(((scale.current - 1) * el.clientHeight) / 2);
                        // Keep coordinates within image bounds
                        if (xPos.current > xPos.max) {
                            xPos.current = xPos.max;
                        }
                        if (xPos.current < -xPos.max) {
                            xPos.current = -xPos.max;
                        }
                        if (yPos.current > yPos.max) {
                            yPos.current = yPos.max;
                        }
                        if (yPos.current < -yPos.max) {
                            yPos.current = -yPos.max;
                        }
                    }

                    if (e.type === 'tap') {
                        e.preventDefault();
                        scale.current++;
                        scale.last = scale.current;

                        if (scale.current > scale.max) {
                            scale.current = 1;
                            xPos.current = 0;
                            yPos.current = 0;
                            xPos.last = xPos.current;
                            yPos.last = yPos.current;
                            scale.last = scale.current;
                            transform = `translate(${xPos.current}px,${yPos.current}px) scale(${scale.current},${scale.current})`;
                            mobileZoomed = true;
                        } else mobileZoomed = false;
                    }
                    // Scale image with pinch
                    if (e.type === 'pinch') {
                        scale.current = Math.max(0.99, Math.min(scale.last * e.scale, scale.max));
                    }
                    // Finish scaling
                    if (e.type === 'pinchend') {
                        scale.last = scale.current;
                    }
                    // Finish panning
                    if (e.type === 'panend') {
                        xPos.last = xPos.current;
                        yPos.last = yPos.current;
                    }

                    // Create scale/pan changes if zoomed in
                    if (scale.current !== 1) {
                        transform = `translate(${xPos.current}px,${yPos.current}px) scale(${scale.current},${scale.current})`;
                    }
                    // Apply transformation
                    if (transform) {
                        el.style.transform = transform;
                    }
                });

                $(el).on('zoom:imageChange', () => {
                    thisHammer.off('tap pan pinch panend pinchend');
                    scale.current = 1;
                    xPos.current = 0;
                    yPos.current = 0;
                    xPos.last = xPos.current;
                    yPos.last = yPos.current;
                    scale.last = scale.current;
                    el.style.transform = `translate(${xPos.current}px,${yPos.current}px) scale(${scale.current},${scale.current})`;
                    el.style['touch-action'] = 'initial';
                    mobileZoomed = false;
                    zoomed = false;
                });
            }

            /** function to create zoom effect on hover
             * @param {jQuery} el - DOM element for current product image
             * @param {number} scale - scale value for the zoom
             */
            function createHoverZoom(el, scale) {
                let hiresUrl = $(el).find('img').attr('data-src-hires');
                if (hiresUrl && hiresUrl !== 'null' && hiresUrl.indexOf('noimagelarge') === -1) {
                    $(el).zoom({
                        on: 'click',
                        url: hiresUrl,
                        touch: false,
                        magnify: scale
                    });
                }
            }

            const setZoomOffset = function () {
                if (!zoomed) {
                    scale *= 1.5;
                    if (scale === 1.18125) {
                        zoomed = true;
                    }
                    createHoverZoom(img, scale);
                } else {
                    $(img).trigger('zoom-destroy');
                    $(img).find('.zoomImg').remove();
                    zoomed = false;
                    scale = 0.35;
                    createHoverZoom(img, scale);
                }
            };

            const allMobileZoom = function (event) {
                const img = event.target;
                if (!zoomed) {
                    img.src = img.getAttribute('data-src-hires');
                    createTouchZoom(img);
                }
                zoomed = true;
                if (!mobileZoomed) {
                    addClass(img.parentNode, 'touch-zoom');
                    $('.primary-images .carousel').carousel('dispose');
                    img.style['touch-action'] = 'none';
                }

                if (mobileZoomed) {
                    removeClass(img.parentNode, 'touch-zoom');
                    $('.primary-images .carousel.image-slider').carousel();
                    $('.primary-images .carousel').on('slide.bs.carousel', () => {
                        $('.primary-images .carousel-item img').trigger('zoom:imageChange');
                    });
                    img.style['touch-action'] = 'initial';
                }
            };

            if (window.matchMedia('(max-width: 1024px)').matches) {
                if (window.matchMedia('(max-width: 768px)').matches) {
                    if (pdpIndicators) {
                        $(pdpIndicators).on('click', () => {
                            const touchZoom = queryFirst('.primary-images .carousel-item.touch-zoom');
                            zoomed = false;
                            mobileZoomed = false;
                            if (touchZoom) {
                                $('.primary-images .carousel-item.touch-zoom img').trigger('zoom:imageChange');
                                removeClass(queryFirst('.primary-images .carousel-item.touch-zoom'), 'touch-zoom');
                            }
                            $('.primary-images .carousel.image-slider').carousel();
                            $('.primary-images .carousel').on('slide.bs.carousel', () => {
                                $('.primary-images .carousel-item img').trigger('zoom:imageChange');
                            });
                        });
                        if (index === 0) {
                            $('.primary-images .carousel').on('slide.bs.carousel', () => {
                                $('.primary-images .carousel-item img').trigger('zoom:imageChange');
                            });
                        }
                    }
                }
                img.addEventListener('click', allMobileZoom);
            } else {
                $(img).one('mouseenter', function () {
                    createHoverZoom(img, scale);
                });
                img.addEventListener('click', () => {
                    $(pdpImages).not($(img)).each(function () {
                        if ($(this).find('.zoomImg').length > 1) {
                            $(this).find('.zoomImg').remove();
                            scale = 0.35;
                            createHoverZoom($(this), scale);
                        }
                    });
                    setZoomOffset();
                });

                imageObserver.observe(img, { childList: true });
            }
        });
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {Array} variationAttributes - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateSelectedSwatchProductName(variationAttributes, $productContainer) {
    if (Array.isArray(variationAttributes) && variationAttributes.length) {
        const colorVariationObject = variationAttributes.find(attribute => attribute.attributeId === 'color');

        if (colorVariationObject && Array.isArray(colorVariationObject.values) && colorVariationObject.values.length) {
            const selectedSwatchObject = colorVariationObject.values.find(eachValue => eachValue.selected);
            let $swatchSection = $productContainer.find('.selected-swatch');
            $swatchSection.find('.selected-swatch-name').text(selectedSwatchObject && $swatchSection.data('color-label') ? $swatchSection.data('color-label').toUpperCase() + selectedSwatchObject.displayValue : '');
        }
    }
}

/**
 * handles size change
 * @param {Object} productContainer - product container html element
 * @param {string} selectedSizeValue - Selected size value
 */
function onSizeChangeHandler(productContainer, selectedSizeValue) {
    const sizeDetailsContainer = queryFirst('.details-text:not(.d-none)', productContainer);
    const selectedSize = queryFirst('.selected-size', sizeDetailsContainer);
    const selectedSizeErrMsg = queryFirst('.select-size-message', productContainer);

    removeClass(queryAll('.size-btn', productContainer), 'selected');
    addClass(this, 'selected');
    addClass(selectedSizeErrMsg, 'd-none');
    const sizeContainer = this.closest('.size-container');
    const assistiveElements = queryAll('.selected-assistive-text', sizeContainer);
    assistiveElements.forEach(eachElement => {
        if (eachElement.textContent.includes(eachElement.dataset.outOfStock)) {
            eachElement.textContent = eachElement.dataset.outOfStock;
        } else {
            eachElement.textContent = '';
        }
    });
    const assistiveElementOfSelected = queryFirst('.selected-assistive-text', this.closest('.size-list'));
    const { selectedText, outOfStock } = assistiveElementOfSelected.dataset;
    assistiveElementOfSelected.textContent = selectedText;
    if (hasClass(this, 'not-available')) {
        assistiveElementOfSelected.textContent += ' ' + outOfStock;
    }
    removeClass(queryFirst('.size-seperator', sizeDetailsContainer), 'd-none');
    selectedSize.textContent = selectedSizeValue;
    removeClass(selectedSize, 'd-none');
}

/**
 * update quickview product info on product variation change
 * @param {string} selectedSizeValue - Selected size value
 * @param {int} selectedColorId - selected color id
 * @param {Object} productContainer - product container html element
 * @param {Object} currentSizeElement - current active size element
 */
function updateQuickViewProductInfo(selectedSizeValue, selectedColorId, productContainer, currentSizeElement) {
    const quickViewInfo = window.quickviewProductInfo;
    const { productInfo } = quickViewInfo;
    const variantGroupData = productInfo.variants[selectedColorId];
    const { sizes, images, formattedPrice, standardPrice, price, vgProductDetailsUrl, isDirectlyPurchasable } = variantGroupData;
    const ispu = base.updateImageDetails(images.ispu);
    const selectedSizeData = sizes[selectedSizeValue];
    const addToCartButton = queryFirst('.add-to-cart', productContainer);
    const hiddenClass = 'd-none';
    const notifyMeButton = queryFirst('.notify-me-btn', productContainer);
    const notifyMeDesc = queryFirst('.notify-me-desc', productContainer);
    const addToCartSection = queryFirst('.prices-add-to-cart-actions', productContainer);
    const availabilityMsgEl = queryFirst('.availability-msg', productContainer);
    let availabilityValue = '';
    let productDetailsUrl = vgProductDetailsUrl;
    const fullPDPLink = queryFirst('.full-pdp-link', productContainer);
    const wishlistButton = queryFirst('.add-to-wish-list', productContainer);

    if (wishlistButton && hasClass(wishlistButton, 'added-to-wish-list')) {
        removeClass(wishlistButton, 'added-to-wish-list');
        wishlistButton.disabled = false;
    }

    if (!selectedSizeData || !currentSizeElement) {
        removeClass(addToCartSection, hiddenClass);
        addClass([notifyMeDesc, notifyMeButton], hiddenClass);
        fullPDPLink.href = productDetailsUrl;
        if (!isDirectlyPurchasable) {
            addToCartButton.disabled = true;
            availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
            availabilityMsgEl.innerHTML = availabilityValue;
        } else {
            addToCartButton.disabled = false;
        }
        return;
    }

    const { isNotifyMeEnabled, ID, forceOutOfStock, variantProductDetailsUrl } = selectedSizeData;
    productDetailsUrl = variantProductDetailsUrl;
    const { productInventory } = quickViewInfo;
    const { variants } = productInventory;
    const inventoryData = variants[ID];
    const { message, availabilityStatus, isLowInventory } = inventoryData;
    const selectedColorName = queryFirst('.selected-swatch-name').textContent;

    if (!isDirectlyPurchasable) {
        availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
    } else if (availabilityStatus !== IN_STOCK || isLowInventory) {
        availabilityValue = availabilityMessageTmpl(message);
    }
    fullPDPLink.href = productDetailsUrl;

    if (!isDirectlyPurchasable) {
        addToCartButton.disabled = true;
        removeClass(addToCartSection, hiddenClass);
        addClass([notifyMeDesc, notifyMeButton], hiddenClass);
    } else if (availabilityStatus !== NOT_AVAILABLE && !forceOutOfStock) {
        addToCartButton.disabled = false;
        removeClass(currentSizeElement, 'not-available');
    } else {
        addClass(currentSizeElement, 'not-available');
        addToCartButton.disabled = true;
        if (isNotifyMeEnabled) {
            addClass(addToCartSection, hiddenClass);
            removeClass([notifyMeDesc, notifyMeButton], hiddenClass);
        } else {
            removeClass(addToCartSection, hiddenClass);
            addClass([notifyMeDesc, notifyMeButton], hiddenClass);
        }
    }

    availabilityMsgEl.innerHTML = availabilityValue;
    productContainer.dataset.pid = ID;
    productContainer.dataset.wishlistId = ID;
    const productData = {
        available: !hasClass(currentSizeElement, 'not-available'),
        isNotifyMeEnabled,
        id: ID,
        formattedPrice,
        forceOutOfStock,
        imageData: ispu
    };
    handleNotifyMe(productData, productContainer);

    // secret sauce integration to update product data
    updateProductData(selectedColorName, selectedSizeValue, standardPrice, price, productContainer);
    handleSize(productContainer);
    $('body').trigger('product:afterQuickViewSizeChange', {
        ID,
        productContainer,
        monetateData: {
            pdpBreadCrumbs: variantGroupData.pdpBreadCrumbs
        }
    });
}

/**
 * Update Scarcity Message on product variation change
 * @param {string} message - Scarcity Message
 * @param {Object} productContainer - product container html element
 */
function updateScarcityMessage(message, productContainer) {
    const fitSizeScarcityLabel = queryFirst('.details-text:not(.d-none) .js-size-scarcity-message', productContainer);

    if (fitSizeScarcityLabel) {
        fitSizeScarcityLabel.innerHTML = message && productContainer.dataset.enableScarcityMessaging === 'true'
            ? `<span> - </span><span class="message">${message}</span>`
            : '';

        if (message === fitSizeScarcityLabel.dataset.oosMsg) {
            addClass(fitSizeScarcityLabel, 'm-accent');
        } else {
            removeClass(fitSizeScarcityLabel, 'm-accent');
        }
    }
}

/**
 * update product info on product variation change
 * @param {string} selectedSizeValue - Selected size value
 * @param {int} selectedColorId - selected color id
 * @param {Object} productContainer - product container html element
 * @param {Object} currentSizeElement - current active size element
 * @param {boolean} isPDPSetPage - is PDP set page
 */
function updateProductInfo(selectedSizeValue, selectedColorId, productContainer, currentSizeElement, isPDPSetPage) {
    const masterId = productContainer.dataset.masterid;
    const productInfo = window.productInfo[masterId];
    const variantGroupData = productInfo.variants[selectedColorId];
    const { sizes, images, formattedPrice, formattedStandardPrice, totalPrice, monogramProductPrice, standardPrice, price, mgFlag, mgLocs, isDirectlyPurchasable } = variantGroupData;
    const ispu = base.updateImageDetails(images.ispu);
    const selectedSizeData = sizes[selectedSizeValue];
    let addToCartButton = '';
    if (hasClass(productContainer, 'custom-set-product')) {
        addToCartButton = queryFirst('.add-to-cart-global');
    } else {
        addToCartButton = queryFirst('.add-to-cart', productContainer);
    }
    const ispuButton = queryFirst('.btn-in-store-pickup', productContainer);
    const hiddenClass = 'd-none';
    const notifyMeButton = queryFirst('.notify-me-btn', productContainer);
    const notifyMeDesc = queryFirst('.notify-me-desc', productContainer);
    const addToCartSection = queryFirst('.prices-add-to-cart-actions', productContainer);
    const availabilityMsgEl = queryFirst('.availability-msg', productContainer);
    const ispuLowStockMsgEl = queryFirst('.ispu-low-stock-msg', productContainer);
    const restrictedMsg = availabilityMsgEl.dataset.restrictedItem;
    const isGlobaleSession = availabilityMsgEl.dataset.isGlobaleSession;
    let availabilityValue = '';

    if (!selectedSizeData || !currentSizeElement) {
        if (ispuButton) {
            ispuButton.disabled = true;
        }
        removeClass(addToCartSection, hiddenClass);
        addClass([notifyMeDesc, notifyMeButton], hiddenClass);
        if (!isDirectlyPurchasable) {
            addToCartButton.disabled = true;
            availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
            availabilityMsgEl.innerHTML = availabilityValue;
            if (ispuButton) {
                ispuButton.disabled = true;
            }
        } else {
            addToCartButton.disabled = false;
        }
        return;
    }

    const { isNotifyMeEnabled, ID, forceOutOfStock, manufacturerSKU, availableForInStorePickup } = selectedSizeData;
    const { variants } = isPDPSetPage ? window.productInventory[masterId] : window.productInventory;
    const inventoryData = variants[ID];
    const {
        message, availabilityStatus, isLowInventory, scarcityMessage
    } = inventoryData;

    updateScarcityMessage(scarcityMessage, productContainer);

    // Shipping preference view
    const shippingPreferencesEnabled = isShippingPreferencesViewEnabled();
    let ispuAvailabilityValue = '';
    let ispuLowStockValue = '';
    let ispuVariants;
    let ispuInventoryData;
    let ispuMessage;
    let ispuLowStockMessage;
    let ispuAvailabilityStatus;
    let isISPULowInventory;
    let isNotEligibleForISPU;
    if (shippingPreferencesEnabled && window.ispuProductInventory) {
        const { variants } = isPDPSetPage ? window.ispuProductInventory[masterId] : window.ispuProductInventory;
        if (variants) {
            ispuInventoryData = variants[ID];
        }
        if (ispuInventoryData) {
            ispuMessage = ispuInventoryData.message;
            ispuLowStockMessage = ispuInventoryData.lowStockAvailabilityMessage;
            ispuAvailabilityStatus = ispuInventoryData.availabilityStatus;
            isISPULowInventory = ispuInventoryData.isLowInventory;
        }
    }

    const selectedColorName = queryFirst('.selected-swatch-name', productContainer).textContent;
    if (!isDirectlyPurchasable) {
        availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
    } else {
        if (availabilityStatus !== IN_STOCK || isLowInventory) {
            const breadcrumbItems = queryAll('.breadcrumb-item');
            const categoryUrl = breadcrumbItems && breadcrumbItems.length > 1 && breadcrumbItems.pop().lastElementChild && breadcrumbItems.pop().lastElementChild.href;
            if (availabilityStatus === NOT_AVAILABLE && categoryUrl) {
                availabilityValue = availabilityMessageOOS(message, categoryUrl);
            } else if (availabilityStatus === PREORDER && categoryUrl) {
                availabilityValue = availabilityMessagePreorder(message, categoryUrl);
            }
            else {
                availabilityValue = availabilityMessageTmpl(message);
            }
            if (isLowInventory) addClass(currentSizeElement, SHIP_TO_LOW_INVENTORY_CLASS);
        }

        // Shipping preference view
        if (ispuAvailabilityStatus && (ispuAvailabilityStatus !== IN_STOCK || isISPULowInventory)) {
            ispuAvailabilityValue = ispuAvailabilityMessageTmpl(ispuMessage);
            ispuLowStockValue = ispuLowStockMessage ? ispuLowStockMessageTmpl(ispuLowStockMessage) : '';
        }
    }

    if (!isDirectlyPurchasable) {
        addToCartButton.disabled = true;
        removeClass(addToCartSection, hiddenClass);
        addClass([notifyMeDesc, notifyMeButton], hiddenClass);
    } else if (((availabilityStatus !== NOT_AVAILABLE || (ispuAvailabilityStatus && ispuAvailabilityStatus !== NOT_AVAILABLE)) &&
        !forceOutOfStock) && !(isGlobaleSession === 'true' && availabilityStatus === PREORDER)) {
        addToCartButton.disabled = false;
        removeClass(currentSizeElement, 'not-available');
    } else {
        addClass(currentSizeElement, 'not-available');
        addToCartButton.disabled = true;
        if (isNotifyMeEnabled) {
            addClass(addToCartSection, hiddenClass);
            removeClass([notifyMeDesc, notifyMeButton], hiddenClass);
        } else {
            removeClass(addToCartSection, hiddenClass);
            addClass([notifyMeDesc, notifyMeButton], hiddenClass);
        }
    }
    availabilityMsgEl.innerHTML = availabilityValue;

    if (availabilityStatus === PREORDER) {
        addClass(currentSizeElement, 'pre-order');
        if (restrictedMsg !== '' && isGlobaleSession === 'true') {
            availabilityValue = restrictedMessageTmpl(restrictedMsg);
            availabilityMsgEl.innerHTML += availabilityValue;
        }
        addClass(queryFirst('.afterpay-paragraph', productContainer), hiddenClass)
    } else {
        removeClass(queryFirst('.afterpay-paragraph', productContainer), hiddenClass)
    }

    if (shippingPreferencesEnabled) {
        $body.trigger('product:inventoryStatus', {
            shipToAddressAvailabilityStatus: availabilityStatus,
            inStorePickUpAvailabilityStatus: ispuAvailabilityStatus || NOT_AVAILABLE,
            isStorePickUpLowInventory: isISPULowInventory,
            inStorePickUpAvailabilityMessage: ispuAvailabilityValue,
            inStorePickUpLowStockMessage: ispuLowStockValue,
            availableForInStorePickup: availableForInStorePickup,
            productContainer
        });
    }
    productContainer.dataset.pid = ID;
    queryFirst('.product-id', productContainer).textContent = ID;
    const manufacturerID = queryFirst('.product-manufacturer-id', productContainer);
    if (null != manufacturerID) {
        manufacturerID.textContent = manufacturerSKU;
    }
    productContainer.dataset.wishlistId = ID;
    const productData = {
        available: !hasClass(currentSizeElement, 'not-available'),
        isNotifyMeEnabled,
        id: ID,
        formattedPrice,
        forceOutOfStock,
        imageData: ispu
    };
    handleNotifyMe(productData, productContainer);
    if (!isDirectlyPurchasable) {
        if (ispuButton) {
            ispuButton.disabled = true;
        }
    } else if (ispuButton) {
        ispuButton.disabled = false;
        ispuButton.dataset.pid = ID;
        const pickupImageElement = queryFirst('.pickup-product-img img', productContainer);
        if (pickupImageElement && ispu) {
            const { alt, url, srcset } = ispu[0];
            const imageHasLoaded = hasClass(pickupImageElement, 'lz-loaded');

            pickupImageElement.setAttribute(imageHasLoaded ? 'src' : 'data-src', url);
            pickupImageElement.setAttribute(imageHasLoaded ? 'srcset' : 'data-srcset', srcset);
            pickupImageElement.setAttribute('alt', alt);
        }
        const pickupSalesPrice = queryFirst('.pickup-price .sale-price', productContainer);
        pickupSalesPrice.textContent = formattedPrice;
        const pickupStandardPrice = queryFirst('.pickup-price .standard-price', productContainer);
        if (formattedStandardPrice !== formattedPrice) {
            pickupStandardPrice.classList.add('mr-2');
            pickupStandardPrice.textContent = formattedStandardPrice;
            pickupSalesPrice.classList.add('has-marked-price');
        }
        queryFirst('.pickup-color .selected-color', productContainer).textContent = selectedColorName.split(':')[1];
        const pickupSize = queryFirst('.pickup-size', productContainer);
        queryFirst('.size-label', pickupSize).textContent = queryFirst('.size-display-name', productContainer).value;
        const sizeSelected = queryFirst('.size-card .size-btn.selected', productContainer);
        if (sizeSelected) {
            queryFirst('.selected-size', pickupSize).textContent = sizeSelected.dataset.attrValue;
        }
    }
    const ispuCheckBoxChecked = queryFirst('.shipping-preferences .preference-ispu', productContainer);
    const availabilityElement = queryFirst('.product-availability .availability-message-text', productContainer);
    if (ispuCheckBoxChecked && ispuCheckBoxChecked.checked) {
        addClass(availabilityElement, HIDDEN_CLASS);
    }
    const product = {};
    if (mgFlag && mgLocs && mgLocs.length > 0) {
        const monogramImages = images.monogram || [];
        let url = '';
        let srcset = '';
        if (monogramImages.length) {
            const updatedImageData = base.updateImageDetails(monogramImages)[0];
            url = updatedImageData.url;
            srcset = updatedImageData.srcset;
        }
        const monogramObject = {
            monogramProductID: ID,
            monogramImageURL: url,
            monogramImageSrcSetURL: srcset,
            monogramLocations: mgLocs,
            monogramSelectedColor: selectedColorName,
            monogramSelectedSize: selectedSizeValue,
            productPrice: formattedPrice,
            monogramProductPrice,
            totalPrice: totalPrice
        };
        product.monogramObject = monogramObject;
    }

    // secret sauce integration to update product data
    updateProductData(selectedColorName, selectedSizeValue, standardPrice, price, productContainer);
    handleSize(productContainer);
}

/**
 * @description Function to update stock for sizes (PDP is cached, so productInventory would be the latest actual)
 * @param {Object} productContainer - The product container DOM element
 */
function updateOutOfStockSizeForPDP(productContainer) {
    if (!productContainer) return;
    const { productInventory, productInfo } = window;
    const productId = productContainer.dataset.masterid;
    const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
    const selectedColorValue = selectedColorElement.dataset.attrValue;
    const variationGroup = productInfo?.[productId]?.variants?.[selectedColorValue];
    if (variationGroup) {
        queryAll('.size-container li', productContainer).forEach(el => {
            const sizeBtn = queryFirst('button', el);
            const attributeValue = sizeBtn.dataset.attrValue;
            const getVariationJson = variationGroup.sizes[attributeValue];
            if (productInventory?.variants?.[getVariationJson?.ID]?.availabilityStatus === NOT_AVAILABLE) {
                addClass(sizeBtn, NOT_AVAILABLE_CLASS);
            } else {
                removeClass(sizeBtn, NOT_AVAILABLE_CLASS);
            }
        });
    }
}

const init = () => {
    $('body').on('product:handleImageZoom', handleProductImageZoom);
    $('.carousel.image-slider').carousel();

    setTimeout(() => {
        setDynamicHeight();
    }, 3000); // Adjust the debounce delay as needed
    updateFitSizeTab();
    const productName = queryFirst('.product-name-row .product-name');
    if (productName) {
        productName.innerHTML = productName.innerHTML.replace(/-/g, '‑');
    }

    base.initMagicNavigation();
};

/**
 * Show the Fit Size Tab if fit size selectable count is greater than one
 */
function updateFitSizeTab() {
    const fitSizeSelectableCountEle = queryAll('.selectableCount');
    fitSizeSelectableCountEle.forEach(fitSizeSelectableCount => {
        const fitSizeSelectableConatiner = fitSizeSelectableCount.closest('.fit-size-tab');
        const sizeAccordionEle = fitSizeSelectableCount.closest('.size-card');
        const fitSizeText = queryFirst('.fitsize-detail-text', sizeAccordionEle);
        const sizeText = queryFirst('.size-detail-text', sizeAccordionEle);
        if (fitSizeSelectableCount) {
            const fitSizeCount = fitSizeSelectableCount.dataset.selectableCount;
            const fitSizes = queryAll('.non-color-attribute.fit-product-type', fitSizeSelectableConatiner);
            if (fitSizes && fitSizes.length > 0) {
                let selectedFit = queryFirst('.non-color-attribute.fit-product-type.selected', fitSizeSelectableConatiner);
                if (!selectedFit) {
                    let firstAvailableFit = fitSizes[0];
                    $(firstAvailableFit).trigger('click');
                }
            }
            if (fitSizeCount > 1) {
                removeClass(fitSizeSelectableConatiner, 'fit-size-tab');
                addClass(sizeText, 'd-none');
                removeClass(fitSizeText, 'd-none');
            } else {
                removeClass(sizeText, 'd-none');
                addClass(fitSizeText, 'd-none');
            }
        }
    });

    updateScarcityMessage('', queryFirst('.product-detail'));
    updateOutOfStockSizeForPDP(queryFirst('.pdp-container'));
}
const handleLastLinkTab = e => {
    const sizeChartCatBtn = queryFirst('#sizechart-menu-toggle');
    const isTabPressed = e.key === TabKey || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (!e.shiftKey) {
        sizeChartCatBtn.focus();
    }
};

export default {
    init: init,

    availability: base.availability,

    addToCart: base.addToCart,

    scrollFitRatingToReviews: function () {
        $(document).on('click', 'button.fit-review, button.no-fit-review', function (e) {
            e.preventDefault();
            const bvReviews = document.getElementById('bazaarvoiceReviews');
            if (bvReviews) {
                scrollTo(window.scrollY + bvReviews.getBoundingClientRect().top, 0);
            }
        });
    },

    handleProductImageZoom: handleProductImageZoom,

    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            const { container } = response;
            const {
                id,
                variationAttributes,
                gtmData,
                gtmGA4Data
            } = response.data.product;
            if ($('.product-detail>.bundle-items').length) {
                container.data('pid', id);
                container.find('.product-id').text(id);
            } else if ($('.product-set-detail').eq(0)) {
                container.data('pid', id);
                container.find('.product-id').text(id);
            } else {
                $('.product-id').text(id);
                $('.product-detail:not(".bundle-item")').data('pid', id);
            }

            const $addToCart = $('.add-to-cart');

            if (gtmData) {
                $addToCart.data('gtmdata', gtmData);
            }

            if (gtmGA4Data) {
                $addToCart.data('gtmga4data', gtmGA4Data);
            }

            updateSelectedSwatchProductName(variationAttributes, container);
            $('body').trigger('product:handleImageZoom');
            updateFitSizeTab();
        });
    },

    selectSizeAttribute: function () {
        $('body').off('click').on('click', '.set-items .size-btn, .product-quickview .size-btn, .quick-buy .size-btn', function (e) {
            e.preventDefault();
            const buttonElement = e.target;
            const $productContainer = $(this).closest('.product-detail');
            if ($productContainer.hasClass('quick-buy')) {
                const $body = $('body');
                const productTileItem = $(this).closest('.product-tile-wrapper')[0];
                const productName = queryFirst('.product-name a', productTileItem)?.textContent;
                const selectedColor = $(this).closest('.product-tile-container').find('.product-tile-swatch.selected').data('swatch-name');
                const plpItemImage = queryFirst('.tile-image', productTileItem);
                let plpItemImageSrcset;
                if (plpItemImage.parentElement.tagName.toLowerCase() === 'picture') {
                    plpItemImageSrcset = queryFirst('source[media="(max-width: 767px)"]', plpItemImage.parentElement).getAttribute('srcset');
                } else {
                    plpItemImageSrcset = plpItemImage.getAttribute('srcset');
                }
                const notifyImageElementMarkup = `<img class="p-img" src="${plpItemImage.getAttribute('src')}" srcset="${plpItemImageSrcset}"
                    alt="${plpItemImage.getAttribute('alt')}" title="${plpItemImage.getAttribute('alt')}" />`;
                const size = $(this).data('attr-value');
                if ($(this).hasClass('not-available')) {
                    if ($(this).data('stock-notification')) {
                        $('.quick-buy-modal').modal('hide');
                        const notifyContainer = queryFirst('.notify-me-container');
                        const notifyImageElement = queryFirst('.notify-product-img', notifyContainer);
                        notifyImageElement.innerHTML = notifyImageElementMarkup;
                        queryFirst('.notify-product-name', notifyContainer).textContent = productName;
                        const productPrice = queryFirst('.price-section .sales .value', productTileItem).innerText;
                        queryFirst('.notify-price', notifyContainer).textContent = productPrice;
                        const pid = $(this).data('variation-id');
                        const sizeLabel = $('.size-display-name').val();
                        const notifySize = queryFirst('.notify-size', notifyContainer);
                        const notifySizeSeperator = queryFirst('.size-seperator', notifyContainer);
                        const notifySelectedSize = queryFirst('.selected-size', notifyContainer);
                        queryFirst('.size-label', notifySize).textContent = sizeLabel;
                        queryFirst('.selected-size', notifySize).textContent = size;
                        removeClass(notifySizeSeperator, 'd-none');
                        removeClass(notifySelectedSize, 'd-none');
                        if (pid) {
                            document.getElementById('notifySku').value = pid;
                        }
                        const custEmail = (document.getElementById('notifyEmail') || {}).value;
                        if (custEmail) {
                            queryFirst('.notify-email', notifyContainer).value = custEmail;
                        }
                        const notifyForm = queryFirst('.notify-form.enable-form-validate', notifyContainer);
                        removeClass(notifyForm, 'd-none');
                        const notifyConfirm = queryFirst('.notify-me-confirm', notifyContainer);
                        addClass(notifyConfirm, 'd-none');
                        $('div.quick-buy-notifyme').first().find('#notifyMe').modal('show');
                    }
                } else {
                    $('.quick-buy-modal').modal('hide');
                    $body.removeClass('modal-open');
                    $('.quick-buy-add-toast .sizeVal').text(size);
                    $('.quick-buy-add-toast .colorVal').text(selectedColor);
                    $('.quick-buy-add-toast .title').text(productName);
                    $('.quick-buy-add-toast .image-container').html(notifyImageElementMarkup);
                    $('.quick-buy-add-toast').attr('is-quick-buy', true);
                    $('.quick-buy .size-btn').removeClass('selected');
                    $(this).addClass('selected');
                    if ($('.pdp-container').length === 0) {
                        queryFirst('.quick-buy-add-to-cart', $productContainer[0]).click();
                    }
                }
            } else {
                const isPDPSetPage = this.closest('.product-set-item');
                if ($productContainer.hasClass('cached-quick-view') && !hasClass(buttonElement, 'selected')) {
                    const productContainer = this.closest('.product-detail');
                    const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
                    const selectedColorId = selectedColorElement.dataset.attrValue;
                    const selectedSizeValue = this.dataset.attrValue;
                    onSizeChangeHandler.apply(this, productContainer, selectedSizeValue);
                    updateQuickViewProductInfo(selectedSizeValue, selectedColorId, productContainer, this);
                } else if (isPDPSetPage) {
                    const productContainerEle = isPDPSetPage;
                    if (!hasClass(productContainerEle, 'scrollable-product-item')) {
                        const url = buttonElement.dataset.attrUrl;
                        base.attributeSelect(url, $productContainer, buttonElement);
                    } else {
                        const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainerEle);
                        const selectedColorIdValue = selectedColorElement.dataset.attrValue;
                        const selectedSizeEleValue = this.dataset.attrValue;
                        onSizeChangeHandler.apply(this, [productContainerEle, selectedSizeEleValue]);
                        $body.trigger('product:pdpSizeSelected', {
                            selectedColorElement,
                            selectedSizeElement: buttonElement,
                            productContainer: productContainerEle
                        });
                        updateProductInfo(selectedSizeEleValue, selectedColorIdValue, productContainerEle, this, isPDPSetPage);
                    }
                    //Code echange to Fix the Scrolling issue on PDP Set page on click on Add all to Cart CTA
                    const availabilityEle = queryFirst('.product-availability', productContainerEle);
                    if (availabilityEle) {
                        $(availabilityEle).attr('data-ready-to-order', true);
                    }
                }
            }
        });
        $('body').on('product:quickViewAttributeChange', (e, response) => {
            const selectedSizeElement = queryFirst('.product-quickview.cached-quick-view .size-btn.selected');
            const selectedValue = selectedSizeElement ? selectedSizeElement.dataset.attrValue : '';
            updateQuickViewProductInfo(selectedValue, response.variantGroupId, response.container[0], selectedSizeElement);
        });
        window.addEventListener('resize', throttle(() => {
            const quickViewCarouselEl = queryFirst('.product-quickview.cached-quick-view .carousel');
            if (quickViewCarouselEl) {
                quickViewCarouselEl.style.minHeight = '';
            }
        }, 16));
    },
    afterAttributeSelect: function () {
        $('body').on('product:afterAttributeSelect', (event, response) => {
            const { selectedSizeElement } = response;
            const { product } = response.data;
            const { id, readyToOrder, available, formattedPrice, formattedStandardPrice, forceOutOfStock, price, wishListID, images, isDirectlyPurchasable } = product;
            const { ispu } = images;
            const responseContainer = response.container[0];
            const addToCartButton = queryFirst('.add-to-cart', responseContainer);
            responseContainer.dataset.pid = id;
            responseContainer.dataset.wishlistId = wishListID;

            let ssSize = 'unknown';
            const hiddenClass = 'd-none';
            if (hasClass(responseContainer, 'product-quickview') && addToCartButton) {
                addToCartButton.disabled = false;
            }
            if (selectedSizeElement) {
                ssSize = selectedSizeElement.dataset.attrValue;
                removeClass(queryAll('.size-btn', responseContainer), 'selected');
                addClass(selectedSizeElement, 'selected');
                const sizeCard = selectedSizeElement.closest('.size-card');
                const selectedSize = queryFirst('.selected-size', sizeCard);
                if (selectedSize) {
                    const sizeSeparator = queryFirst('.size-seperator', sizeCard);
                    selectedSize.textContent = selectedSizeElement.dataset.attrValue;
                    removeClass([sizeSeparator, selectedSize], hiddenClass);
                }
                const sizeContainer = selectedSizeElement.closest('.size-container');
                const assistiveElements = queryAll('.selected-assistive-text', sizeContainer);
                assistiveElements.forEach(eachElement => {
                    if (eachElement.textContent.includes(eachElement.dataset.outOfStock)) {
                        eachElement.textContent = eachElement.dataset.outOfStock;
                    } else {
                        eachElement.textContent = '';
                    }
                });
                const assistiveElementOfSelected = queryFirst('.selected-assistive-text', selectedSizeElement.closest('.size-list'));
                const { selectedText, outOfStock } = assistiveElementOfSelected.dataset;
                assistiveElementOfSelected.textContent = selectedText;
                if (hasClass(selectedSizeElement, 'not-available')) {
                    assistiveElementOfSelected.textContent += ' ' + outOfStock;
                }
                if (addToCartButton) {
                    addToCartButton.disabled = !readyToOrder || !available || forceOutOfStock;
                }

                const quickviewContainer = selectedSizeElement.closest('.product-quickview');
                if (quickviewContainer) {
                    const addToCartSection = queryFirst('.prices-add-to-cart-actions', responseContainer);
                    const notifyMeButton = queryFirst('.notify-me-btn', responseContainer);
                    const notifyMeDesc = queryFirst('.notify-me-desc', responseContainer);
                    const availabilityMessageEl = queryFirst('.product-availability', responseContainer);
                    const { isNotifyMeEnabled, isDirectlyPurchasable } = product;
                    const salesPrice = price.type === 'range' ? price.min.sales : price.sales;
                    const productData = {
                        available,
                        isNotifyMeEnabled,
                        id,
                        formattedPrice: salesPrice.formatted,
                        forceOutOfStock,
                        imageData: ispu
                    };
                    handleNotifyMe(productData, quickviewContainer);
                    const updateCartButton = queryFirst('.update-cart-product-global', quickviewContainer);
                    if (updateCartButton) {
                        const { giftWrapAvailableFlag } = product;
                        updateCartButton.dataset.giftWrapAvailable = giftWrapAvailableFlag;
                    }
                    if (isDirectlyPurchasable === false) {
                        removeClass(addToCartSection, hiddenClass);
                        if (availabilityMessageEl) {
                            removeClass(availabilityMessageEl, hiddenClass);
                        }
                        addClass([notifyMeDesc, notifyMeButton], hiddenClass);
                    }
                }

                const ispuButton = queryFirst('.btn-in-store-pickup', responseContainer);
                if (ispuButton) {
                    ispuButton.dataset.pid = id;
                    ispuButton.disabled = false;
                    const pickupImageElement = queryFirst('.pickup-product-img img', responseContainer);
                    if (pickupImageElement && ispu) {
                        const { alt, url, srcset } = ispu[0];
                        pickupImageElement.setAttribute('src', url);
                        pickupImageElement.setAttribute('srcset', srcset);
                        pickupImageElement.setAttribute('alt', alt);
                    }
                    queryFirst('.pickup-product-name', responseContainer).textContent = product.productName;
                    const pickupSalesPrice = queryFirst('.pickup-price .sale-price');
                    if (pickupSalesPrice) {
                        pickupSalesPrice.textContent = (product.price && product.price.sales) ? product.price.sales.formatted : '';
                    }
                    const pickupStandardPrice = queryFirst('.pickup-price .standard-price');
                    if (formattedStandardPrice !== formattedPrice && pickupStandardPrice) {
                        pickupStandardPrice.classList.add('mr-2');
                        pickupStandardPrice.textContent = formattedStandardPrice;
                        pickupSalesPrice.classList.add('has-marked-price');
                    }
                    const selectedSwatchName = queryFirst('.selected-swatch-name', responseContainer);
                    if (selectedSwatchName) {
                        queryFirst('.pickup-color .selected-color', responseContainer).textContent = selectedSwatchName.textContent;
                    }
                    const pickupSize = queryFirst('.pickup-size', responseContainer);
                    queryFirst('.size-label', pickupSize).textContent = queryFirst('.size-display-name', responseContainer).value;
                    const sizeSelected = queryFirst('.size-card .size-btn.selected', responseContainer);
                    if (sizeSelected) {
                        queryFirst('.selected-size', pickupSize).textContent = sizeSelected.dataset.attrValue;
                    }
                }
            }
            if (hasClass(responseContainer, 'product-quickview') && isDirectlyPurchasable === false) {
                const addToCartSection = queryFirst('.prices-add-to-cart-actions', responseContainer);
                const notifyMeButton = queryFirst('.notify-me-btn', responseContainer);
                const notifyMeDesc = queryFirst('.notify-me-desc', responseContainer);
                const availabilityMessageEl = queryFirst('.product-availability', responseContainer);
                removeClass(addToCartSection, hiddenClass);
                if (addToCartButton) {
                    addToCartButton.disabled = true;
                }
                if (availabilityMessageEl) {
                    removeClass(availabilityMessageEl, hiddenClass);
                }
                addClass([notifyMeDesc, notifyMeButton], hiddenClass);
            }
            const wishlistButton = queryFirst('.add-to-wish-list', responseContainer);
            if (wishlistButton && hasClass(wishlistButton, 'added-to-wish-list')) {
                removeClass(wishlistButton, 'added-to-wish-list');
                wishlistButton.disabled = false;
                const assistiveText = wishlistButton.getAttribute('data-assistive-text');
                wishlistButton.setAttribute('aria-label', assistiveText);
            }
            if (!hasClass(responseContainer, 'gift-card-main') && !document.getElementById('chooseBonusProductModal')) {
                const ssColorElement = queryFirst('.color-container .color-attribute.selected', responseContainer);
                const ssColor = (ssColorElement && ssColorElement.dataset.attrDisplayvalue) || 'unknown';
                const { type } = price;
                const pricesObject = type === 'range' ? price.min : price;
                const { sales, list } = pricesObject;
                const ssSalesPrice = ((sales && sales.value) ? sales.value.toString() : 'unknown') || 'unknown';
                const ssPrice = ((list && list.value) ? list.value.toString() : ssSalesPrice) || ssSalesPrice;
                updateProductData(ssColor, ssSize, ssPrice, ssSalesPrice, responseContainer);
                if (ssSize === 'unknown') {
                    handleColor(responseContainer);
                } else {
                    handleSize(responseContainer);
                }
            }
            if (selectedSizeElement) {
                const productSetModal = selectedSizeElement.closest('#productSetModal');
                if (productSetModal) {
                    const addAllToToteButton = queryFirst('.add-to-cart-global', productSetModal);
                    if (addAllToToteButton) {
                        const productsAvailability = queryAll('.product-availability', productSetModal).filter(item => !hasClass(item.closest('.product-detail'), 'hidden-set'));
                        const numberOfProducts = productsAvailability.length;

                        // Check to enable add to tote button, if atleast one product exists
                        let enable = true;
                        if (!numberOfProducts) {
                            enable = false;
                        }
                        addAllToToteButton.disabled = !enable;
                    }
                }
            }
            setTimeout(() => {
                setDynamicHeight();
            }, 200);
            updateFitSizeTab();
            $.spinner().stop();
        });
    },
    selectPdpSizeAttribute: function () {
        $(document).on('click', '.pdp-container .size-btn', function (e) {
            e.preventDefault();

            const productContainer = this.closest('.product-detail');
            const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
            const selectedColorId = selectedColorElement.dataset.attrValue;
            const selectedSizeValue = this.dataset.attrValue;
            onSizeChangeHandler.apply(this, [productContainer, selectedSizeValue]);
            $body.trigger('product:pdpSizeSelected', {
                selectedColorElement,
                selectedSizeElement: this,
                productContainer
            });
            $('.sku-section').removeClass('d-none');
            updateProductInfo(selectedSizeValue, selectedColorId, productContainer, this);
        });
        $('body').on('product:afterAttributeChange', (e, response) => {
            const selectedSizeElement = queryFirst('.pdp-container .size-btn.selected');
            const selectedValue = selectedSizeElement ? selectedSizeElement.dataset.attrValue : '';
            updateProductInfo(selectedValue, response.variantGroupId, response.container[0], selectedSizeElement);
        });

        const swatchEl = queryFirst('.pdp-container button.color-attribute .swatch-circle.selected');

        if (swatchEl) {
            const sizeElements = queryAll('.pdp-container .size-btn');

            if (sizeElements.length) {
                if (sizeElements.length === 1) {
                    queryFirst('.pdp-container .size-btn').click();
                } else {
                    const selectedSizeEl = queryFirst('.pdp-container .size-btn.selected');

                    if (selectedSizeEl) {
                        selectedSizeEl.click();
                    }
                }

                if (!queryFirst('.pdp-container .size-btn.not-purchasable')) {
                    const allSizesSoldOut = sizeElements.every((sizeElement) => hasClass(sizeElement, 'not-available'));

                    if (allSizesSoldOut) {
                        removeClass(swatchEl, 'selectable');

                        const allSelectableSwatches = queryAll('.pdp-container button.color-attribute .swatch-circle.selectable');
                        const notifyMeDesc = queryFirst('.notify-me-desc.d-none');

                        if (allSelectableSwatches.length && notifyMeDesc.length) {
                            // Hide the selected swatch because it's out of stock
                            addClass(swatchEl.closest('li'), 'd-none');
                            allSelectableSwatches[0].click();
                        }
                    }
                }
            }
        }
    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer
                .find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            const productSetModal = document.getElementById('productSetModal');
            const quickViewModal = document.getElementById('quickViewModal');
            if (productSetModal && hasClass(productSetModal, 'show')) {
                $(productSetModal)
                    .spinner()
                    .start();
            } else if (quickViewModal && hasClass(quickViewModal, 'show')) {
                $(quickViewModal)
                    .spinner()
                    .start();
            } else {
                $.spinner().start();
            }
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .attr('data-ready-to-order', response.product.readyToOrder)
                .attr('data-available', response.product.available);

            var availabilityValue = '';
            var availabilityMessages = response.product.availability.messages;
            if (response.product.readyToOrder) {
                availabilityMessages.forEach(message => {
                    availabilityValue += availabilityMessageTmpl(message);
                });
            }

            $('.availability-msg', response.$productContainer)
                .empty()
                .html(availabilityValue);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        var $prodSizeChart = $('.size-chart-collapsible');
        $('body').on('click', '.size-chart .size-chart-link', function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var $lpSlideout = $('.lp-sizechart');
            var activeCategoryVal = $(this).data('sizefamily');
            var defaultText = $(this).data('defaulttext');
            const setStickyNav = queryFirst('.custom-set-detail-sticky-nav');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    },
                    complete: function () {
                        var $activeCategoryEl = $prodSizeChart.find(`a[href="#${activeCategoryVal}-size"]`);
                        var $lpSizechartTitle = $prodSizeChart.find('.lp-sizechart-category-btn');
                        $lpSizechartTitle.focus();
                        $activeCategoryEl.tab('show');
                        $lpSizechartTitle.text($activeCategoryEl.text().length ? $activeCategoryEl.text() : defaultText);

                        $prodSizeChart.animate(
                            {
                                right: '0'
                            },
                            500
                        );
                        $prodSizeChart.addClass('active');
                        $lpSlideout.toggleClass('lp-slideout-open');
                        $body.toggleClass(sizeChartClasses);

                        const lastLinkEl = queryFirst('.return-policy-link');
                        if (lastLinkEl) {
                            lastLinkEl.addEventListener('keydown', handleLastLinkTab);
                        }
                    }
                });
            } else {
                $prodSizeChart.toggleClass('active');
                $lpSlideout.toggleClass('lp-slideout-open');
                $body.toggleClass(sizeChartClasses);
            }
            if (setStickyNav) {
                addClass(setStickyNav, 'd-none');
            }
            $lpSlideout.trigger('shown.lp.sizeguide');
        });

        $('body').on('click touchstart', function (e) {
            if (e.target.matches('#sizechart-close') || (e.target.matches('.size-chart-bg') && $prodSizeChart.hasClass('active'))) {
                $prodSizeChart.removeClass('active');
                $('.lp-slideout').removeClass('lp-slideout-open');
                $body.removeClass(sizeChartClasses);
            }
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    renderSizeElements: base.renderSizeElements,
    handleEarlyAccessPLPLockIcon: base.handleEarlyAccessPLPLockIcon(),
    handleEarlyAccessLockIcon: function () {
        const productContainer = queryFirst('.pdp-container');
        const productContainerEarlyAccessIcon = queryFirst('.loyalty-early-access-lock-container', productContainer);
        if (productContainerEarlyAccessIcon) {
            const { earlyAccessDate } = productContainerEarlyAccessIcon.dataset;
            const earlyAccessItem = isEarlyAccessElement(earlyAccessDate);
            base.handleEarlyAccessCta(productContainer, earlyAccessItem);
        }
    },
    handleOflineProduct: function () {
        const offlineContainerEl = queryFirst('.offline-product-detail');
        if (offlineContainerEl) {
            const pid = offlineContainerEl.dataset.pid;
            const inventoryData = window.productInventory;
            if (inventoryData && inventoryData.variants) {
                const data = inventoryData.variants[pid];
                if (data && data.availabilityStatus === IN_STOCK) {
                    location.search = (location.search ? location.search + '&' : '') + 'timestamp=' + new Date().getTime();
                }
            }
        }
    }
};

/**
 * Set dynamic height for carousel indicators based on main image height.
 */
function setDynamicHeight() {
    const pdpContainer = document.querySelector('.container-fluid.product-detail');
    if (!pdpContainer) return;

    const carousels = pdpContainer.querySelectorAll('.primary-images .carousel');
    carousels.forEach((carousel) => {
        const imgContainer = pdpContainer.querySelector('.primary-images');
        const carouselIndicators = carousel.querySelector('.carousel-indicators-images');
        const mainImageHeight = imgContainer ? imgContainer.clientHeight : 0;
        if (carouselIndicators) {
            carouselIndicators.style.maxHeight = `${mainImageHeight}px`;
        }
    })
}

/**
 * Debounce function to handle window resize event.
 */
function handleResize() {
    clearTimeout(resizeTimeout);
    let resizeTimeout = setTimeout(() => {
        setDynamicHeight();
    }, 200); // Adjust the debounce delay as needed
}

/**
 * Attach event listener for window resize using the debounce mechanism.
 */
window.addEventListener('resize', handleResize);

